import * as React from 'react';

import Avatar from './Avatar';

import AvatarAvatar from '../../Img/avatar.jpg'

/* NOTE: requires user log in */
class AvatarVisual extends React.Component {
    public render() {
        return (
            <div>
                <Avatar size="small" imageUrl={AvatarAvatar} />
                <Avatar size="medium" imageUrl={AvatarAvatar} />
            </div>
        );
    }

    public voidFn = () => {
        /* this is not empty */
    };
}

export default AvatarVisual;


// WEBPACK FOOTER //
// ./src/App/Elements/Avatar.visual.tsx